import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeToggleService {
  darkMode = new BehaviorSubject<String>('');
  private renderer: Renderer2;
  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  applyTheme(mode: string) {
    const html = document.documentElement;
    html.classList.remove(
      'light-gold',
      'dark-gold',
      'light-legacy',
      'dark-legacy'
    );
    html.classList.add(mode);
  }
}
